export const animateSlider = (carousel, rotateHandler) => {
  const rotateInt = parseInt(carousel?.dataset?.rotateInt || 0)
  const inner = carousel?.querySelector('.inner-carousel')
  const cards = carousel?.querySelectorAll('.inner-carousel > div')
  let depthFactor = 0.6
  const screenWidth = window.innerWidth

  if (screenWidth <= 380) {
    depthFactor = 0.6
    inner.style.right = '10px'
  } else if (screenWidth <= 420) {
    depthFactor = 1
    inner.style.right = '10px'
  } else if (screenWidth <= 480) {
    depthFactor = 0.9
  } else {
    depthFactor = 0.6
    inner.style.right = '20px'
  }

  const size = cards?.length
  const panelSize = inner?.clientWidth
  const translateZ = Math.round(panelSize / 2 / Math.tan(Math.PI / size)) * depthFactor
  const ry = 360 / size

  for (let i = 0; i < size; i++) {
    const z = rotateInt * ry + i * ry
    const child = cards[i]
    child.style.transform = `rotateY(${z}deg) translateZ(${translateZ}px) rotateY(${-z}deg)`
    child.classList.remove('clockwise', 'front', 'counterclockwise')
    child.style.zIndex = 'auto'

    child.removeEventListener('click', rotateHandler)

    const zz = z % 360

    if (zz === 0) {
      child.classList.remove('animation-slide')
      child.classList.add('front')
      child.style.zIndex = 100
    } else if (zz === ry || zz === -360 + ry) {
      child.classList.add('clockwise')
      child.classList.remove('animation-slide')
      if (screenWidth <= 380) {
        child.style.transform += `translateZ(${translateZ + 20}px) translateY(23dvh) translateX(40px)`
      } else if (screenWidth <= 420) {
        child.style.transform += `translateZ(${translateZ + 20}px) translateY(23dvh) translateX(40px)`
      } else if (screenWidth <= 480) {
        child.style.transform += `translateZ(${translateZ + 20}px) translateY(23dvh) translateX(40px)`
      } else {
        child.style.transform += `translateZ(${translateZ + 20}px) translateY(15dvh) translateX(80px)`
      }
    } else if (zz === 360 - ry || zz === 0 - ry) {
      child.classList.add('counterclockwise')
      child.classList.remove('animation-slide')
      if (screenWidth <= 380) {
        child.style.transform += `translateZ(${translateZ + 20}px) translateY(23dvh) translateX(-55px)`
      } else if (screenWidth <= 480) {
        child.style.transform += `translateZ(${translateZ + 20}px) translateY(23dvh) translateX(-55px)`
      } else {
        child.style.transform += `translateZ(${translateZ + 20}px) translateY(15dvh) translateX(-80px)`
      }
    } else if (zz === 270 || zz === -90) {
      if (screenWidth <= 380) {
        child.style.transform += `translateZ(${translateZ + 10}px) translateY(15dvh) translateX(-10px)`
      } else if (screenWidth <= 480) {
        child.style.transform += `translateZ(${translateZ + 10}px) translateY(15dvh) translateX(15px)`
      } else {
        child.style.transform += `translateZ(${translateZ + 10}px) translateY(8dvh) translateX(-10px)`
      }
    } else if (zz === 135 || zz === -225) {
      if (screenWidth <= 380) {
        child.style.transform += `translateZ(${translateZ + 100}px) translateY(15dvh) translateX(10px)`
      } else if (screenWidth <= 480) {
        child.style.transform += `translateZ(${translateZ + 100}px) translateY(15dvh) translateX(20px)`
      } else {
        child.style.transform += `translateZ(${translateZ + 100}px) translateY(8dvh) translateX(40px)`
      }
    } else if (zz === 225 || zz === -135) {
      if (screenWidth <= 380) {
        child.style.transform += `translateZ(${translateZ}px) translateY(6dvh) translateX(-5px)`
      } else if (screenWidth <= 480) {
        child.style.transform += `translateZ(${translateZ}px) translateY(6dvh) translateX(0px)`
      } else {
        child.style.transform += `translateZ(${translateZ}px) translateY(2dvh) translateX(-20px)`
      }
    } else if (zz === 90 || zz === -270) {
      if (screenWidth <= 380) {
        child.style.transform += `translateZ(${translateZ}px) translateY(6dvh) translateX(-30px)`
      } else if (screenWidth <= 480) {
        child.style.transform += `translateZ(${translateZ}px) translateY(6dvh) translateX(-40px)`
      } else {
        child.style.transform += `translateZ(${translateZ}px) translateY(2dvh) translateX(-10px)`
      }
    } else {
      if (screenWidth <= 380) {
        child.style.transform += 'translateY(2dvh) translateX(-10px)'
      } else if (screenWidth <= 480) {
        child.style.transform += 'translateY(1.5dvh) translateX(-10px)'
      } else {
        child.style.transform += 'translateY(-4dvh) translateX(-10px)'
      }
    }

    if (
      !(
        child.classList.contains('clockwise') ||
        child.classList.contains('front') ||
        child.classList.contains('counterclockwise')
      )
    ) {
      child.classList.add('animation-slide')
    }
  }
}
